import {$authHost, $host} from "./index";
import jwt_decode from "jwt-decode";
import axios from "axios";
export const registration = async (email, nickname, password) => {
    try {
        const response = await $host.post('api/user/registration', {email, nickname, password})
        if (response.data.accessToken) {
            localStorage.setItem('token', response.data.accessToken)
            return jwt_decode(response.data.accessToken)
        }

        // Если регистрации по коду → возвращаем сообщение и данные юзера
        return {
            message: response.data.message,
            user: response.data.user
        }

    } catch (e) {
        const errorMessage = e.response?.data?.message || 'Произошла неизвестная ошибка при регистрации.';
        // Выбрасываем новую ошибку с этим сообщением
        throw new Error(errorMessage);
    }
}
export const login = async (email, password) => {
    try  {
        const response = await $host.post('api/user/login', {email, password})

        if (response.data.accessToken) {
            localStorage.setItem('token', response.data.accessToken)
            return jwt_decode(response.data.accessToken)
        }

        return {
            message: response.data.message,
            user: response.data.user
        }
    } catch (e) {
        const errorMessage = e.response?.data?.message || 'Произошла неизвестная ошибка при входе.';
        // Выбрасываем новую ошибку с этим сообщением
        throw new Error(errorMessage);
    }
}

export const loginByCode = async (email, code) => {
    try {
        // Отправляем email и код на роут для завершения входа
        const response = await $host.post('api/user/login/code', { email, code });

        // Если вход успешен, бэкенд возвращает токены
        if (response.data.accessToken) {
            // Сохраняем access токен
            localStorage.setItem('token', response.data.accessToken);
            // Возвращаем данные пользователя из токена
            return jwt_decode(response.data.accessToken);
        }

        // Этот блок на всякий случай, если бэкенд не вернул токены
        return response.data;

    } catch (e) {
        const errorMessage = e.response?.data?.message || 'Произошла неизвестная ошибка при входе по коду.';
        // Выбрасываем новую ошибку с этим сообщением
        throw new Error(errorMessage);
    }
}

export const logout = async () => {
    return await $authHost.post('api/user/logout')
}

export const sendLoginCode = async (email) => {
    try{
        const {data} = await $host.post('api/user/login/code/send', { email })
        return data
    } catch (e) {
        const errorMessage = e.response?.data?.message || 'Произошла неизвестная ошибка при получении пользователя.';
        // Выбрасываем новую ошибку с этим сообщением
        throw new Error(errorMessage);
    }
}


export const check = async () => {
    try {
        const response = await axios.get(`${process.env.REACT_APP_API_URL}api/user/refresh`, {withCredentials: true})
        localStorage.setItem('token', response.data.accessToken);
        return jwt_decode(response.data.accessToken)
    } catch (e) {

    }
}

export const fetchOneUser = async (id) => {
    try{
        const {data} = await $host.get('api/user/' + id)
        return data
    } catch (e) {
        const errorMessage = e.response?.data?.message || 'Произошла неизвестная ошибка при получении пользователя.';
        // Выбрасываем новую ошибку с этим сообщением
        throw new Error(errorMessage);
    }
}

export const updateNickname = async (newNickname) => {
    try {
        const { data } = await $authHost.put('api/user/nickname', { nickname: newNickname });
        return data; // вернёт { message, user }
    } catch (e) {
        const errorMessage = e.response?.data?.message || 'Ошибка при обновлении никнейма.';
        throw new Error(errorMessage);
    }
};

export const updateProfilePhoto = async (formData) => {
    try {
        const { data } = await $authHost.put('api/user/photo', formData, {
        });

        return data;
    } catch (e) {
        const errorMessage = e.response?.data?.message || 'Ошибка при обновлении фото профиля.';
        throw new Error(errorMessage);
    }
};
